module.exports = __webpack_public_path__ + "img/imagen3.2e6cdeea.png";